export { MarqueeText } from './MarqueeText'
export type { MarqueeTextProps } from './MarqueeText'
